// extracted by mini-css-extract-plugin
module.exports = {"container":"_2_w0e4wuD8u8RWbKBgp92v","switchActive":"_1EjDmYZrFaPQ6bpSEhN0c-","switchLabel":"_7xn9dbAq-SELjkPgRP5_l"};